export enum RequestType {
    InStock = 'Stock',
    GLP = 'GLP',
    Radioactive = 'Radioactive',
}